/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_status_stable = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stable`)
};

const es_home_status_stable = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estable`)
};

const de_home_status_stable = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stabil`)
};

const nl_home_status_stable = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stabiel`)
};

const fr_home_status_stable = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stable`)
};

const it_home_status_stable = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stabile`)
};

const pt_br2_home_status_stable = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estável`)
};

const pt_home_status_stable = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estável`)
};

const ja_home_status_stable = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安定版`)
};

const zh_home_status_stable = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稳定版`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_status_stable = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_status_stable(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_status_stable", locale)
	if (locale === "en") return en_home_status_stable(inputs)
	if (locale === "es") return es_home_status_stable(inputs)
	if (locale === "de") return de_home_status_stable(inputs)
	if (locale === "nl") return nl_home_status_stable(inputs)
	if (locale === "fr") return fr_home_status_stable(inputs)
	if (locale === "it") return it_home_status_stable(inputs)
	if (locale === "pt-BR") return pt_br2_home_status_stable(inputs)
	if (locale === "pt") return pt_home_status_stable(inputs)
	if (locale === "ja") return ja_home_status_stable(inputs)
	return zh_home_status_stable(inputs)
};